import { Flex, useAudio } from "@aircall/tractor";
import { useCallback } from "react";
import { useTrackAudioSpeed } from "@/hooks/useTrackAudioSpeed/useTrackAudioSpeed";
import { useBaseStore } from "@/store/store";
import { speedOptions } from "./PlayerSpeedControls.constants";
import { SpeedButton } from "./SpeedButton";
import { SpeedPicker } from "./SpeedPicker";

type PlayerSpeedControlsProps = {
  disabled?: boolean;
};

export function PlayerSpeedControls({
  disabled = false,
}: PlayerSpeedControlsProps) {
  const isExpanded = useBaseStore((store) => store.isExpanded);

  const trackAudioSpeed = useTrackAudioSpeed();

  const { setSpeed, speed } = useAudio();

  const onSpeedChange = useCallback(
    (v: number) => {
      setSpeed(v);
      trackAudioSpeed(v);
    },
    [setSpeed, trackAudioSpeed]
  );

  return isExpanded ? (
    <Flex
      alignItems="center"
      justifyContent="start"
      data-test="speed-configuration"
    >
      {speedOptions.map((o) => (
        <SpeedButton
          key={o.val}
          isActive={o.val === speed}
          onClick={() => {
            onSpeedChange(o.val);
          }}
          disabled={disabled}
        >
          {o.label}
        </SpeedButton>
      ))}
    </Flex>
  ) : (
    <SpeedPicker value={speed} onChange={onSpeedChange} disabled={disabled} />
  );
}
